export default __webpack_public_path__ + "static/media/Automation_Best_Practices_for_SRE_and_Security_SREDay_London_2023.488c0ccd.jpg";